import type { TicketActorType, TicketReply } from "../../models/Ticket";

export const TICKET_TYPE_LABELS: Record<string, string> = {
  "0": "客服",
  "1": "货源",
  "2": "订单",
  customer: "客服",
  cargo: "货源",
  order: "订单",
};

export const TICKET_TYPE_COLORS: Record<string, "default" | "primary" | "success" | "warning" | "info"> = {
  "0": "default",
  "1": "primary",
  "2": "success",
  customer: "default",
  cargo: "primary",
  order: "success",
};

export const getTicketTypeLabel = (rawType?: string | number | null): string => {
  if (rawType === undefined || rawType === null || rawType === "") {
    return "客服";
  }
  const key = String(rawType);
  return TICKET_TYPE_LABELS[key] ?? rawType;
};

export const getTicketTypeColor = (rawType?: string | number | null): "default" | "primary" | "success" | "warning" | "info" => {
  if (rawType === undefined || rawType === null || rawType === "") {
    return "default";
  }
  const key = String(rawType);
  return TICKET_TYPE_COLORS[key] ?? "default";
};

export const isReplyFromCurrentUser = (
  reply: TicketReply,
  currentUserId?: string | null
): boolean => {
  if (reply.isSelf) {
    return true;
  }
  if (currentUserId && reply.senderId && reply.senderId === currentUserId) {
    return true;
  }
  return false;
};

export const isAiReply = (reply: TicketReply): boolean => {
  if (reply.isAi) {
    return true;
  }
  if (reply.senderType === "ai") {
    return true;
  }
  return false;
};

export const getSenderDisplayName = (
  reply: TicketReply,
  currentUserId?: string | null
): string => {
  if (isAiReply(reply)) {
    return reply.senderName || "AI 助手";
  }
  if (isReplyFromCurrentUser(reply, currentUserId) || !reply.senderId) {
    return reply.senderName || "我";
  }
  return reply.senderName || reply.senderId || "我";
};

export const getActorType = (
  reply: TicketReply,
  currentUserId?: string | null
): TicketActorType => {
  if (isAiReply(reply)) {
    return "ai";
  }
  if (isReplyFromCurrentUser(reply, currentUserId)) {
    return "user";
  }
  if (reply.senderType) {
    return reply.senderType;
  }
  return "staff";
};
